// used to add embeded rows within an AG Grid column
import React from "react"
import "./EmbeddedRowsCell.scss"

type HocProps = {
  children: React.ReactNode
  className?: string
  style?: React.CSSProperties
}

const EmbeddedRowsCellTable = ({ children, className, style = {} }: HocProps) => {
  return (
    <div
      className={`embedded-rows-cell__row`}
      style={style}
    >
      <div className={`embedded-rows-cell__cell${className ? " " + className : ""}`}>{children}</div>
    </div>
  )
}

const EmbeddedRowsCell = ({ children, className, style = {} }: HocProps) => {
  return (
    <div
      className={`embedded-rows-cell${className ? " " + className : ""}`}
      style={style}
    >
      {children}
    </div>
  )
}

EmbeddedRowsCell.Cell = EmbeddedRowsCellTable

export default EmbeddedRowsCell
